module.exports = __webpack_public_path__ + "img/鸡骨草.3a54baec.jpg";